import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "base-header" }
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = { class: "infos" }
const _hoisted_8 = {
  key: 0,
  class: "name ellipsis"
}
const _hoisted_9 = {
  key: 1,
  class: "type ellipsis"
}
const _hoisted_10 = { class: "arrow" }
const _hoisted_11 = {
  key: 0,
  class: "box-menu"
}
const _hoisted_12 = { class: "menu-content" }

import { computed, ref } from "vue";
import { svgIcon } from "@/common/components";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { removeUser } from "@/common/services/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-header',
  props: {
    width: { default: "15rem" },
    height: { default: "4rem" },
    background: { default: "#fff" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v0986b7bf": (_ctx.width),
  "v0d81464e": (_ctx.height),
  "c8b7c256": (_ctx.background)
}))

const { t, tm } = useI18n();
const router = useRouter();



const showMenu = ref(false);
const showMessages = ref(false);

const types = computed(() => tm("technical.types") as Record<string, string>);

function goTo(url: string) {
  showMenu.value = false;
  router.push(url);
}

function logout() {
  removeUser();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/images/logo.png')
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("section", _hoisted_4, [
      (showMessages.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "box-messages" }, "messages", -1)),
            _createTextVNode(" " + _toDisplayString(types.value), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", {
        class: "content",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMenu.value = !showMenu.value))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(svgIcon), {
            icon: "person",
            size: "1.5rem"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.$store.getters.profile?.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$store.getters.profile?.name), 1))
            : _createCommentVNode("", true),
          (_ctx.$store.getters.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(types.value[_ctx.$store.getters.type] ?? ""), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (showMenu.value)
            ? (_openBlock(), _createBlock(_unref(svgIcon), {
                key: 0,
                icon: "arrow-up",
                size: "1rem"
              }))
            : (_openBlock(), _createBlock(_unref(svgIcon), {
                key: 1,
                icon: "arrow-down",
                size: "1rem"
              }))
        ])
      ]),
      (showMenu.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "exit",
                  size: "1.75rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.exit")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})